//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from 'react';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import { useTranslation } from 'react-i18next';

// custom pages
import CollapsibleTable from 'components/Table/CollapsibleTable';
import styles from './styles';
import Loader from 'components/Loader/Loader';

import LinearProgress from '@material-ui/core/LinearProgress';

export default function Issued(props) {
  const {
    data,
    offset,
    count,
    setOffset,
    currentTab,
    viewMore,
    setViewMore,
    viewMoreEnd,
    noData,
    response,
    loading,
  } = props;

  const classes = styles();
  const { t, i18n } = useTranslation();

  // const callback = () => {
  //   if (offset[currentTab] !== 1) {
  //     if (viewMoreEnd[currentTab]?.length == 0) {
  //       setOffset({ ...offset, [currentTab]: offset[currentTab] + 1 });
  //     }
  //   }
  // };
  // const scrollRef = useBottomScrollListener(callback);

  let headings = [
    "Order Date",
    "Post Date",
    "Order Number",
    "Location Account #",
    "Business Name",
    "Points Earned",
    "Purchase Amount", 
    "Action",
  ];

  const handlePagination = (value) => {
   console.log(value,'this is the paginationvalues')
    setOffset({ ...offset, [currentTab]: value });
  };
  
  return (
    <React.Fragment>
      {(response && !loading)? (
        <div className='points-issued-table-wrapper'>
          <div
            className={
              viewMore[currentTab] ? classes.tableDiv : classes.tableDiv2
            }
            id='earned'
            // ref={scrollRef}
          >
            <CollapsibleTable
              data={data}
              headings={headings.map((i) => (
                <div key={t(i)} className={classes.issuedHeadings}>{t(i)}</div>
              ))}
              subHeadings={[
                t("Item Code"),
                t("Line #"),
                t("Product Description"),
                t("Order Date"),
                t("Post Date"),
                t("Order Amount"),
                t("Earn Rate"),
                t("Promo Description"),
                t("Promo Multiplier"),
                t("Points"),
              ]}
              keys={[
                "order_date",
                "post_date",
                "order_number",
                "customer_account_number",
                "loyalty_organization_name",
                "points",
                "extended_sales_amount",
              ]}
              subKeys={[
                "product_code",
                "line_number",
                "product_short_description",
                "order_date",
                "post_date",
                "extended_sales_amount",
                "tier_ratio",
                "rule_description",
                "multiplier",
                "points",
              ]}
              sorting={true}
              sortingFields={{ column: 'Order Date', row: 'order_date' }}
              offset={offset[currentTab]}
              count={
                (count / 10) % 1 == 0
                  ? Math.floor(count / 10)
                  : Math.floor(count / 10 + 1)
              }
              handlePagination={handlePagination}
              collapsible={true}
              currentTab={currentTab}
              language={i18n.language}
              disablePagination={false}
            />
          </div>
          {/* {!noData[currentTab] && !viewMore[currentTab] && (
            <div
              className={classes.viewMore}
              style={{ fontSize: '1rem' }}
              onClick={() => {
                setViewMore({ ...viewMore, [currentTab]: true });
                setOffset({ ...offset, [currentTab]: offset[currentTab] + 1 });
              }}
            >
              <span className={classes.viewMoreText}>{t('View More')}</span>
            </div>
          )} */}
        </div>
      ) : (
        <Loader Loading={!response} top={'15%'}></Loader>
      )}
      {viewMore[currentTab] && loading ? (
        <LinearProgress style={{ margin: '10px 0px', color: '#3891CB' }} />
      ) : null}
    </React.Fragment>
  );
}
